import { CAT_RUNNER_PRE_ITEM_TYPES } from '../mockBackend';

export const CAT_RUNNING_ITEM_TYPES = [
  CAT_RUNNER_PRE_ITEM_TYPES.SHIELD,
  CAT_RUNNER_PRE_ITEM_TYPES.MAGNET,
];

export const itemUseCountFromUsage = (usage = {}) =>
  Math.max(0, Number(usage?.used ?? 0)) + Math.max(0, Number(usage?.reused ?? 0));

export const itemUsageToUseCounts = (itemUsage = {}) =>
  CAT_RUNNING_ITEM_TYPES.reduce((counts, itemType) => {
    counts[itemType] = itemUseCountFromUsage(itemUsage?.[itemType]);
    return counts;
  }, {});

export const createInitialItemUseCounts = () => itemUsageToUseCounts({});

export const getItemMaxUses = ({ shieldArmed = false, magnetArmed = false, itemType }) => {
  if (itemType === CAT_RUNNER_PRE_ITEM_TYPES.SHIELD) {
    return shieldArmed ? 2 : 1;
  }
  if (itemType === CAT_RUNNER_PRE_ITEM_TYPES.MAGNET) {
    return magnetArmed ? 2 : 1;
  }
  return 0;
};

export const getSnackCostForUse = ({ shieldArmed = false, magnetArmed = false, itemType, useCount = 0 }) => {
  if (itemType === CAT_RUNNER_PRE_ITEM_TYPES.SHIELD) {
    if (shieldArmed) {
      if (useCount === 0) return 0;
      if (useCount === 1) return 1;
      return null;
    }
    if (useCount === 0) return 2;
    return null;
  }

  if (itemType === CAT_RUNNER_PRE_ITEM_TYPES.MAGNET) {
    if (magnetArmed) {
      if (useCount === 0) return 0;
      if (useCount === 1) return 1;
      return null;
    }
    if (useCount === 0) return 2;
    return null;
  }

  return null;
};

export const getNextItemUsePlan = ({
  shieldArmed = false,
  magnetArmed = false,
  itemType,
  useCount = 0,
  snackCount = 0,
}) => {
  const maxUses = getItemMaxUses({ shieldArmed, magnetArmed, itemType });
  const snackCost = getSnackCostForUse({ shieldArmed, magnetArmed, itemType, useCount });
  const canUse = snackCost !== null && useCount < maxUses && snackCount >= snackCost;
  const remainingUses = Math.max(0, maxUses - useCount);

  return {
    snackCost: snackCost ?? 0,
    maxUses,
    canUse,
    remainingUses,
    isFree: snackCost === 0,
    isExhausted: useCount >= maxUses,
  };
};

export const getArmedFlagsFromPreItems = (preItems = []) => ({
  shieldArmed: preItems.includes(CAT_RUNNER_PRE_ITEM_TYPES.SHIELD),
  magnetArmed: preItems.includes(CAT_RUNNER_PRE_ITEM_TYPES.MAGNET),
});
